import { crudActions } from "@/services/CrudActions";

export default {
  ...crudActions("administradores-fincas"),
};
